import { useState, FC } from 'react'
import { Copy, Check } from 'lucide-react'

interface FunctionSignatureProps {
  signature: string
}

export const FunctionSignature: FC<FunctionSignatureProps> = ({ signature }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(signature)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="ns-function-signature-container">
      <div className="ns-signature-header">
        <span className="ns-signature-label">Signature</span>
        <button
          type="button"
          onClick={handleCopy}
          className="ns-signature-copy-btn"
          title="Copy signature"
        >
          {copied ? (
            <>
              <Check size={14} className="text-forest" />
              <span>Copied</span>
            </>
          ) : (
            <>
              <Copy size={14} />
              <span>Copy</span>
            </>
          )}
        </button>
      </div>
      <div className="ns-signature-code-block">
        <code>{signature}</code>
      </div>
    </div>
  )
}
